import { Dialog } from '@bsf/force-ui';
import Video from './video/video';
import useStore, { actionTypes } from '@/store';

const VideoModal = () => {
	const {
		dispatch,
		videoModalOpen: open,
		currentVideoModalItem: item,
	} = useStore();

	const handleVideoModalOpen = () => {
		dispatch( {
			type: actionTypes.SET_VIDEO_MODAL_OPEN,
			payload: false,
		} );
	};

	return (
		<Dialog
			design="simple"
			exitOnEsc
			scrollLock
			exitOnClickOutside
			open={ open }
			setOpen={ handleVideoModalOpen }
		>
			<Dialog.Backdrop />
			<Dialog.Panel className="w-[90vw] max-w-[672px] max-h-[85vh] sm:max-h-[80vh] mx-auto rounded-lg border-none">
				<Dialog.Body className="p-0">
					<Video url={ item?.url } title={ item?.title } />
				</Dialog.Body>
			</Dialog.Panel>
		</Dialog>
	);
};

export default VideoModal;
